import { useTheme } from '@mui/material';
import Logotype from './logotype.svg?react';
import LogotypeWhite from './logotype_white.svg?react';
import LogotypeSmall from './logotype_small.svg?react';
import LogotypeSmallWhite from './logotype_small_white.svg?react';
import './style.css';

export type LogoProps = {
    white?: boolean;
    size?: 'sm' | 'md' | 'lg';
};

export default function Logo({ white = false, size = 'md' }: LogoProps) {
    const darkMode = useTheme().palette.mode === 'dark';
    // This component is used for size of either "md" || "lg"
    const LogoComponent = white ? LogotypeWhite : Logotype;
    const logoClassName = white
        ? 'bino-logo-white'
        : darkMode
          ? 'bino-logo-dark'
          : 'bino-logo';

    switch (size) {
        case 'md': {
            return (
                <LogoComponent
                    width={132}
                    height={48}
                    className={logoClassName}
                />
            );
        }
        case 'lg': {
            return (
                <LogoComponent
                    width={200}
                    height={70}
                    className={logoClassName}
                />
            );
        }
        default: {
            const LogoSmallComponent = white
                ? LogotypeSmallWhite
                : LogotypeSmall;
            return (
                <LogoSmallComponent
                    width={101}
                    height={31}
                    className={logoClassName}
                />
            );
        }
    }
}
